<ng-container *ngIf="splats">
  <div class="title" fxLayout="row" fxLayoutAlign="space-between end">
    <h1>{{ 'SPLATS情報' | translate }}</h1>
  
    <div class="basic-button" fxLayoutGap="10px">
      <button mat-raised-button color="primary" (click)="setSplats()" [disabled]="splatsFormGroup.invalid">
        <mat-icon>add</mat-icon>
        <span>{{ isAdded? '追加' : '更新' | translate }}</span>
      </button>
    </div>
  </div>


  <div fxLayout="column" fxLayoutAlign="center center">
    <form class="form" [formGroup]="splatsFormGroup" style="width: 85%;">


      <div fxLayout="row" fxLayoutGap="20px">
        <!-- 画面右部 -->
        <div fxFlex="50%" fxLayout="column" fxLayoutGap="20px">

          <!-- 共用環境アクセストークン -->
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'共用環境アクセストークン' | translate}}</mat-label>
            <input matInput placeholder="{{'共用環境アクセストークン' | translate}}" id="shareAccessToken" formControlName="shareAccessToken">
          </mat-form-field>

        </div>

        <!-- 画面左部 -->
        <div fxFlex="50%" fxLayout="column" fxLayoutGap="20px">

          <!-- 本番環境アクセストークン -->
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'本番環境アクセストークン' | translate}}</mat-label>
            <input matInput placeholder="{{'本番環境アクセストークン' | translate}}" id="productionAccessToken" formControlName="productionAccessToken">
          </mat-form-field>

        </div>

      </div>
    </form>
  </div>
</ng-container>
